/** @format */
import { MarkupStringViewComponent, TranspileComponent } from 'sis-components';
import courseUnitInfoTextFieldTpl from './courseUnitInfoTextField.tpl.html';
export const courseUnitInfoTextFieldModule = 'student.common.components.courseUnitInfoTextField';
(function () {
  angular.module(courseUnitInfoTextFieldModule, [TranspileComponent.downgrade.moduleName, MarkupStringViewComponent.downgrade.moduleName]).component('courseUnitInfoTextField', {
    bindings: {
      headingKey: '<',
      fieldValue: '<',
      fieldValueMarkup: '<',
      md: '<'
    },
    template: courseUnitInfoTextFieldTpl,
    controller: CourseUnitInfoTextFieldController
  });
  function CourseUnitInfoTextFieldController() {
    var ctrl = this;
    ctrl.fieldValueHasValue = function () {
      return ctrl.fieldValue && ctrl.fieldValue !== '';
    };
    ctrl.fieldValueMarkupHasValue = function () {
      return ctrl.fieldValueMarkup && ctrl.fieldValueMarkup !== '';
    };
  }
})();